import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { OpenDialog } from '../../../shared/dialogs/dialog';
import { PortalDisclaimerComponent } from '../../shared/portal-disclaimer/portal-disclaimer.component';
import { AccountService } from '../../../services/account.service';
import * as moment from 'moment';

@Component({
  selector: 'app-cal-disclaimer',
  templateUrl: './cal-disclaimer.component.html',
  styleUrls: ['./cal-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalDisclaimerComponent implements OnInit {
  currentYear = moment().format('YYYY');
  currentUser = null;

  constructor(private accountService: AccountService, private cdRef: ChangeDetectorRef) {}

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    this.cdRef.detectChanges();
  }

  openDisclaimer() {
    OpenDialog(PortalDisclaimerComponent, { close: true, accept: this.currentUser.researchDisclaimerAccepted });
  }
}
